__turbopack_context__.v({
  "tooltip": "mantineTooltip-module-scss-module__5eG5cq__tooltip",
});
